export default {
    toDict(list, keyPropNm) {
        let dataMap = {};
        if(typeof list !== 'undefined') {
            list.forEach(function(data) {
                var keyValue = "";
                if(typeof keyPropNm === 'function') {
                    keyValue = keyPropNm(data);
                } else {
                    keyValue = data[keyPropNm];
                }

                if(typeof data !== 'undefined' && typeof keyValue !== 'undefined') {
                    dataMap[keyValue] = data;
                }
            });
        }

        return dataMap;
    },
    toMap(list, keyPropNm) {
        let dataMap = {};
        if(typeof list !== 'undefined') {
            list.forEach(function(data) {
                var keyValue = "";
                if(typeof keyPropNm === 'function') {
                    keyValue = keyPropNm(data);
                } else {
                    keyValue = data[keyPropNm];
                }

                if(typeof data !== 'undefined' && typeof keyValue !== 'undefined') {
                    if(typeof dataMap[keyValue] === 'undefined') {
                        dataMap[keyValue] = [];
                    }
                    dataMap[keyValue].push(data);
                }
            });
        }

        return dataMap;
    },
    toList(map) {
        let list = [];
        for (const [key, entry] of Object.entries(map)) {
            if(Array.isArray(entry)) {
                entry.forEach(d => {
                    list.push(d);
                });
            } else {
                list.push(entry);
            }
        }
        return list;
    },
    toCurrency: function(val) {
        if(typeof val !== 'undefined') {
            return Math.round(val).toLocaleString();
        } else {
            return '';
        }
    },
    separateCurrencyUnit(number) {
        let  inputNumber  = number < 0 ? false : number;
        let  unitWords    = ['일', '만', '억', '조', '경'];
        let  splitUnit    = 10000;
        let  splitCount   = unitWords.length;
        let  resultArray  = [];
        let  result = {'일': 0, '만': 0, '억': 0, '조': 0, '경': 0};

        for (let  i = 0; i < splitCount; i++){
            let  unitResult = (inputNumber % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i);
            unitResult = Math.floor(unitResult);
            if (unitResult > 0){
                resultArray[i] = unitResult;
            }
        }

        for (let  i = 0; i < resultArray.length; i++){
            if(!resultArray[i]) continue;
            result[unitWords[i]] = resultArray[i];
        }

        return result;
    },
    // 억단위까지만 단위 붙히기
    addCurrencyUnit(number) {
        let result = "";
			let num = number.toString();
			for(let i=0; i<num.length; i++) {
				let str = num.charAt(num.length-(i+1));
				if(i == 4) str += "만";
				if(i == 8) str += "억";
				if(i == 12) str += "조";
				result = str + result;
			}
			let total = result.split('억');
			return total[0] + '억' ;
    },
    // 문자열 Date형으로 변환
    stringToDate(val) {
        let baseDay = val || '';
        let dayStr = '';

        if(baseDay !== '') {
            baseDay = baseDay.replace(/-/gi, "");
            baseDay = baseDay.replace(/:/gi, "");
            baseDay = baseDay.replace(/ /gi, "");
        }

        if(baseDay.length >= 8) {
            let date = new Date();

            let y = baseDay.substring(0, 4);
            let m = baseDay.substring(4, 6);
            let d = baseDay.substring(6, 8);

            date.setFullYear(y);
            date.setMonth(m- 1, d);

            if(baseDay.length >= 10) {
                let h = baseDay.substring(8, 10);
                date.setHours(h);
            }

            if(baseDay.length >= 12) {
                let min = baseDay.substring(10, 12);
                date.setMinutes(min);
            }

            if(baseDay.length >= 14) {
                let sec = baseDay.substring(12, 14);
                date.setSeconds(sec);
            }

            return date;
        } else {
            return "";
        }
    },
}
